const types = {
    received: 1,
    sent: 2
};

export default types;